import ShoppingBagIcon from "@/components/atoms/dynamic-icons/shopping-bag";
import ShopStallIcon from "@/components/atoms/dynamic-icons/shop-stall";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import Link from "next/link";
import HandshakeIcon from "@/components/atoms/dynamic-icons/handshake";
import { getMarketplaceUrl } from "@/lib/marketplace-utils";

export default function JoinEcosystem() {
  const paymentOptions = [
    {
      id: "customer",
      title1: "Shop as a Customer",
      description: "Buy from trusted vendors with flexible payment options.",
      cta: "Sign up",
      cta2: "Sign in",
      icon: ShoppingBagIcon,
      link: "/register/worker/sign-up",
      link2: "/login",
    },
    {
      id: "vendor",
      title1: "Sell on Onyx",
      description: "Reach more customers and get paid securely.",
      cta: "Join as a Vendor",
      icon: ShopStallIcon,
      link: "https://vendor.onyxng.com",
    },
    {
      id: "sales-agent",
      title1: "Sell as a Sales Agent",
      description: "Promote products and earn commissions on sales.",
      cta: "Sell as a Sales Agent",
      link: "/become-sales-agent",
      icon: HandshakeIcon,
    },
  ];
  return (
    <div className='mx-auto w-full px-4 pt-12 md:max-w-5xl md:px-0 md:pt-30'>
      <h3 className='text-text-title mb-7 text-center text-3xl'>Join the Onyx Ecosystem</h3>
      <div className='grid grid-cols-1 gap-5 md:grid-cols-3 md:justify-between md:gap-4 xl:gap-7'>
        {paymentOptions.map((option) => (
          <Card key={option.id} className='flex h-full'>
            <CardContent className='flex h-full flex-col px-4 xl:px-6'>
              <div className='border-border-title mx-auto flex size-12 items-center justify-center rounded-full border-3 md:size-17'>
                <option.icon className='text-icon-title size-8 md:size-10' />
              </div>
              <p className='text-icon-disabled mt-6 text-center text-xs leading-4 font-semibold md:text-sm'>
                {option.description}
              </p>
              <div className='hidden text-text-title mt-4 text-center text-lg leading-5 font-medium sm:text-xl sm:leading-7 xl:text-3xl'>
                {option.title1}
              </div>
              <div className='mt-auto flex w-full items-center gap-2'>
                <Link
                  href={
                    option.id === "customer" || option.id === "sales-agent"
                      ? getMarketplaceUrl(option.link)
                      : option.link
                  }
                  className='w-full flex-1'
                >
                  <Button className='mt-5 w-full py-6'>{option.cta}</Button>
                </Link>
                {option.cta2 && (
                  <Link href={getMarketplaceUrl(option.link2)}>
                    <Button variant={"ghost"} className='mt-5 w-full flex-1 py-6 underline'>
                      {option.cta2}
                    </Button>
                  </Link>
                )}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      <p className='text-text-title mt-10 text-center text-base font-semibold md:mt-20 md:text-lg lg:mx-auto lg:max-w-xl'>
        Onyx is a trusted online marketplace offering flexible payment options, secure shopping, and verified vendors.
      </p>
    </div>
  );
}
